export default __webpack_public_path__ + "static/media/3. incidents.6049eee5.png";